import { ZPlayNetworkService } from "commons";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class ProductService {
	public static getProduct = (productId: string, successCallback: any, errorCallback: any) => {
		ZPlayNetworkService.get(`${API_BASE_URL}/api/products/${productId}`, successCallback, errorCallback);
	};
}
